import { render, staticRenderFns } from "./edit-odometer.vue?vue&type=template&id=50b99a34&scoped=true&"
import script from "./edit-odometer.vue?vue&type=script&lang=js&"
export * from "./edit-odometer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b99a34",
  null
  
)

export default component.exports